export default "__VITE_ASSET__8897c15c__"